import { AdminMenuUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchTestXConstruct = (page: number) => {
  return new AdminMenuUseCase(
    `/construto/teste-construtos?pagina=${page}`,
    makeAxiosHttpClient()
  )
}
export const saveTestXConstruct = (cdTeste: string, cdConstruto: string) => {
  return new AdminMenuUseCase(
    `/teste/teste-construto?cdConstruto=${cdConstruto}&cdTeste=${cdTeste}`,
    makeAxiosHttpClient()
  )
}
